module.exports = __webpack_public_path__ + "images/3d0863c6d93bbf7500a6fc35a5afd5d57.png";